import { render, staticRenderFns } from "./OnBoarding.vue?vue&type=template&id=3e2fe116&scoped=true&"
import script from "./OnBoarding.vue?vue&type=script&lang=js&"
export * from "./OnBoarding.vue?vue&type=script&lang=js&"
import style0 from "./OnBoarding.vue?vue&type=style&index=0&id=3e2fe116&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2fe116",
  null
  
)

export default component.exports